export default __webpack_public_path__ + "static/media/Junk_Food_16_9.a660bba1.png";